export default __webpack_public_path__ + "static/water_filter_w.ddf08e7241071f015ae28193785b4189.png";